import React from 'react';
import CustomModel from './CustomModel';
export default class UserModal extends React.Component {
  constructor() {
    super();
  }
  render() {
    return (
      <CustomModel title={this.props.title} body={this.body()} show={this.props.show} hide={this.props.hide} />
    )
  }
  body() {
    const user = this.props.user;
    var strDate = "";
    if (user && user.joinDate) {
      let date = new Date(user.joinDate);
      let month = date.getMonth() + 1
      strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    return <React.Fragment>
      <div className="modal-body">
        {user && <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <td width="150">
                {
                  user.profilePic ? <img src={user.profilePic} height="150" alt="" /> : <img src={user.profilePic} alt="No Pic" />
                }
              </td>
              <td>
                <ul>
                  <li className="row">
                    <div className="col-lg-6"><strong>User's Name</strong></div>
                    <div className="col-lg-6">{user.fullName}</div>
                  </li>
                  <li className="row">
                    <div className="col-lg-6"><strong>Email</strong></div>
                    <div className="col-lg-6">{user.email}</div>
                  </li>
                  <li className="row">
                    <div className="col-lg-6"><strong>Phone Number</strong></div>
                    <div className="col-lg-6">{user.phoneNumber}</div>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>Address</strong></td>
              <td>{user.address}</td>
            </tr>
            <tr>
              <td><strong>Registration Date</strong></td>
              <td>{strDate}</td>
            </tr>
          </tbody>
        </table>}
      </div>
      {this.props.footer}
    </React.Fragment >
  }
}


// WEBPACK FOOTER //
// ./src/modal/UserModal.js